<template>
  <div id="landing-view">
    <vue-particles id="tsparticles" @particles-loaded="particlesLoaded" :options="particlesJSON" />
    <div id="landing-content">
      <h1 id="landing-title"><s>echoslip</s></h1>
      <h2>in development</h2>
      inspired by the magic: the gathering forgetful fish fan game mode
    </div>
  </div>
</template>


<script>
import 'tsparticles';
import particlesJSON from '../assets/particles.json';

export default {
  name: 'LandingView',
  data () {
    return {
      particlesJSON: particlesJSON
    }
  }
}
</script>

<style scoped>
#landing-view {
  width: 100%;
  height: 100%;

  background-color: #A2BFFE;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#landing-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  z-index: 2;
}

#landing-title {
  font-size: 5rem;
}
</style>